import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import FormBuilder from "../../../../components/forms/formBuilder";

class FormBuilderModal extends Component {
    render() {
        const { isOpen, toggle, editedForm, saveForm, editing, cancelEdit } = this.props;
        return <Modal isOpen={isOpen} toggle={toggle} className="fullscreen">
            <div className='modalHeader ph-20 ' style={{ borderBottom: '1px solid var(--background)' }}>
                <div className="headerContainer" style={{ maxWidth: 'unset', minHeight: 60, height: 60 }}>

                    <div >
                        <h2>Form Builder</h2>
                        <h3>{editedForm.name}</h3>
                    </div>
                    <div className="flex">

                        <button className="neu mr-15 " onClick={() => {
                            if (editing) {
                                if (window.confirm('Are you sure you want to discard your changes?')) {
                                    cancelEdit();
                                }
                            } else {
                                toggle();
                            }
                        }}>{editing ? "Discard Changes" : "Close"}</button>
                        <button className={`neu  ${!editing ? 'disabled' : 'prim'}`}
                            onClick={saveForm}>Save</button>
                    </div>
                </div>
            </div>
            <ModalBody className="modalBody">
                <FormBuilder {...this.props} />
            </ModalBody>
        </Modal>
    }
}

export default FormBuilderModal;